module.exports = __webpack_public_path__ + "static/media/Instrumental.1e4ba9b3.jpg";